<template>
  <BFormGroup
    :state="state"
    :invalid-feedback="errorMessage"
    class="mb-3"
  >
    <b-form-label :required="required" :forId="inputId" :id="labelId" :class="{'fw-bold': required}">
      {{ label }}
    </b-form-label>
    <select
      v-model="selectValue"
      :id="inputId"
      :name="inputName"
      :class="['form-select', { 'fw-bold': required }]"
      :aria-required="required ? 'true' : undefined"
      :aria-invalid="invalid ? 'true' : undefined"
      :aria-labelledby="labelId"
    >
      <option value="">{{ placeholder }}</option>
      <option v-for="option in options" :value="option[1]">
        {{ option[0] }}
      </option>
      <optgroup v-for="(group, name) in optionGroups" :label="name">
        <option v-for="option in group" :value="option[1]">
          {{ option[0] }}
        </option>
      </optgroup>
    </select>
  </BFormGroup>
</template>

<script>
  import BFormLabel from './BFormLabel.vue'
  import { BFormGroup } from 'bootstrap-vue-next'

  export default {
    components: {
      "b-form-label": BFormLabel,
      BFormGroup
    },
    data() {
      return {
        errorMessages: this.errors
      }
    },
    computed: {
        state() {
            return this.invalid ? false : null;
        },
        invalid() {
            return !!this.errorMessages.length;
        },
        selectValue: {
            get() {
                return this.value ?? '';
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        inputName() {
            return `${this.modelName}[${this.attrName}]`;
        },
        inputId() {
            return `${this.modelName}_${this.attrName}`;
        },
        labelId() {
            return `${this.inputId}_label`;
        },
        errorMessage() {
            return this.errorMessages.join(' and ');
        },
    },
    props: {
      value: {
        type: [String, null],
        default: ''
      },
      label: {
        type: String,
        required: true
      },
      required: {
        type: Boolean,
        default: false
      },
      modelName: {
        type: String,
        required: true
      },
      attrName: {
        type: String,
        required: true
      },
      errors: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      },
      placeholder: {
        type: String,
        default: ''
      },
      optionGroups: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>
